import { IconBell, IconHelpCircle, IconPlus, IconSearch, IconSidebar } from 'featherico';
import triggerPopupAlert from '../../react/components/PopupAlert/trigger';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import { NavItemButton } from '../../react/features/Navigation/Item';
import { useAppContext } from '../../react/hooks/useAppContext';
import styles from './style.m.less';

type Props = {
    onExpand: () => void;
};

const showNotImplementedAlert = () => triggerPopupAlert('Not implemented in the compact navigation yet.', 'error');

export default function ActionsCompact({ onExpand }: Props) {
    const { user } = useAppContext();
    return (
        <div className={styles.container}>
            <div className={styles.section}>
                <NavItemButton icon={<IconPlus />} label="Create" compact onClick={showNotImplementedAlert} />
                <NavItemButton icon={<IconSearch />} label="Search" compact onClick={showNotImplementedAlert} />
                <NavItemButton icon={<IconHelpCircle />} label="Help" compact onClick={showNotImplementedAlert} />
                <NavItemButton icon={<IconBell />} label="Notifications" compact onClick={showNotImplementedAlert} />
            </div>
            <div className={styles.section}>
                <NavItemButton icon={<IconSidebar />} label="Expand Navigation" compact onClick={onExpand} />
                <UserMenu user={user} compact />
            </div>
        </div>
    );
}
